import { useEffect, useState } from 'react';
// import Label from '../Label/Label';
import ClimateProject from '../ClimateProject/ClimateProject';
import useStore from '@/stores/useStore';
import { Loader } from '@/components/blocks';
import { Footer } from '@/components/containers';
import globeSm from '../../assets/globe-sm.svg';
import About from '../About/About';
// import Approach from '../Approach/Approach';
import './Landing.scss';
import LabelIntro from '../LabelIntro/LabelIntro';
// import Discover from '../Discover/Discover';
import apiHelper from '../../services/ApiService';
import CarbonFootprintInfo from '../Carbon Footprint Info/CarbonFootprintInfo';
import CookieConsentBanner from '../../components/blocks/CookieConcent/CookieConcentBanner';

const LandingPage = ({ translation }: any) => {
    // const [labels, setLabels] = useState<any>();
    // const [showDiscoverSection, setShowDiscoverSection] = useState<boolean>();
    const data = useStore((state) => state.data);
    const [isCookieGranted, setIsCookieGranted] = useState(false)

    useEffect(() => {
        const updateCSSVariables = () => {
            const root = document.documentElement;
            for (const [key, value] of Object.entries(data?.branding[0])) {
                if (!key.startsWith('$') && key !== 'footerImage' && key !== 'headerImage' && value)
                    root.style.setProperty(`--${key}`, value as string);
            }
        };
        if (data?.branding?.length > 0)
            updateCSSVariables();
    }, [data?.branding]);

    useEffect(() => {
        if (data?.company?.name && isCookieGranted) {
            window.dataLayer.push({
                'event': 'pageview',
                'company_name': data?.company?.name,
            });
            console.log(data?.company?.name)
        }
    }, [data?.company?.name, isCookieGranted]);

    const handleConsent = () => {
        const gtmId = 'GTM-P2M7NBW7';

        const script = document.createElement('script');
        script.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;
        j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
        f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${gtmId}');
        `;
        document.head.appendChild(script);

        const noscript = document.createElement('noscript');
        noscript.innerHTML = `
        <iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>
        `;
        document.body.appendChild(noscript);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'cookie_consent_granted',
        });
        setIsCookieGranted(true)
    };

    // useEffect(() => {
    //     const getData = async () => {
    //         const bodyObj = {
    //             action: 'getRelatedLabels',
    //             body: {
    //                 vatNumber: data.metadata.vatNumber,
    //                 language: i18n.language,
    //             },
    //         };
    //         const relatedLabels = await apiHelper.ExecuteEpsilon(bodyObj);
    //         if (relatedLabels?.length > 0) {
    //             const index = relatedLabels.findIndex(
    //                 (x: any) => x.$dataScope === data.metadata.$dataScope
    //             );
    //             if (index !== -1) relatedLabels.splice(index, 1);
    //             const lablesByCat = {
    //                 entity: relatedLabels.filter(
    //                     (x: any) => x.type?.trim()?.toLowerCase() === 'entity'
    //                 ),
    //                 product: relatedLabels.filter(
    //                     (x: any) =>
    //                         x.type?.trim()?.toLowerCase() === 'product' ||
    //                         x.type?.trim()?.toLowerCase() === 'produit'
    //                 ),
    //                 activity: relatedLabels.filter(
    //                     (x: any) => x.type?.trim()?.toLowerCase() === 'activity'
    //                 ),
    //                 company: relatedLabels.filter(
    //                     (x: any) => x.type?.trim()?.toLowerCase() === 'company'
    //                 ),
    //                 event: relatedLabels.filter(
    //                     (x: any) => x.type?.trim()?.toLowerCase() === 'event'
    //                 ),
    //                 site: relatedLabels.filter(
    //                     (x: any) => x.type?.trim()?.toLowerCase() === 'site'
    //                 ),
    //             };
    //             setShowDiscoverSection(
    //                 !!(
    //                     lablesByCat?.activity?.length > 0 ||
    //                     lablesByCat?.entity?.length > 0 ||
    //                     lablesByCat?.product?.length > 0 ||
    //                     lablesByCat?.event?.length > 0 ||
    //                     lablesByCat?.site?.length > 0 ||
    //                     lablesByCat?.company?.length > 0
    //                 )
    //             );
    //             setLabels(lablesByCat);
    //         }
    //     };
    //     if (data?.metadata?.vatNumber) getData();
    // }, [data]);

    return (
        <>
            {data && (
                <>
                    <CookieConsentBanner onConsentGiven={handleConsent} />
                    {!data && <Loader />}
                    {data.metadata && (
                        <>
                            <LabelIntro
                                metadata={data.metadata}
                                company={data.company}
                                translation={translation}
                            // showDiscoverBtn={showDiscoverSection}
                            />
                            <img className='about-globe' src={globeSm} alt='' />
                        </>
                    )}
                    {data.metadata && (
                        <>
                            <About
                                metadata={data.metadata}
                                translation={translation}
                            />
                            <img
                                className='about-globe-l'
                                src={globeSm}
                                alt=''
                            />
                        </>
                    )}
                    {data.metadata && (
                        <>
                            <CarbonFootprintInfo
                                metadata={data.metadata}
                                translation={translation}
                            />
                            {/* <MultipleClimateProjects
                                metadata={data.metadata}
                                projects={data.projects}
                                translation={translation}
                            /> */}
                            <ClimateProject
                                metadata={data.metadata}
                                projects={data.projects}
                                translation={translation}
                            />

                            <img className='label-globe' src={globeSm} alt='' />
                        </>
                    )}
                    {/* <Approach translation={translation} /> 

                    {data.metadata?.type?.toLowerCase() !== 'activity' && (
                        <Label
                            metadata={data.metadata}
                            translation={translation}
                            type={data.metadata?.type}
                        />
                    )}
                    {showDiscoverSection && (
                        <Discover
                            translation={translation}
                            company={data.company}
                            labels={labels}
                        />
                    )}
                    */}
                    <Footer
                        ariaLabel={'Footer'}
                        branding={data.settings[0]}
                        translation={translation}
                    />
                </>
            )}
        </>
    );
};

export default LandingPage;
